import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/common/hooks/useAuth';
import URL from '@/common/routes/Url';
import React from 'react';

import { RoleType } from '@/common/constants/Role';

type Props = {
  role: RoleType;
};

const Gate: React.FC<Props> = ({ role }) => {
  const { user } = useAuth();

  useLayoutEffect(() => {
    if (role < user.role) {
      window.location.href = URL.signin;
    }
  }, [user.role]);

  return <Outlet />;
};

export default Gate;
